/**
 * Converts raw number, string, or Date to a Date object.
 */
const parseToDate = (date) => {
    const dateStringValue = String(date);
    // Check if input is a raw UNIX timestamp (must convert to Date)
    if (dateStringValue.match(/^\d{10}$|^\d{13}$/)) {
        const timestamp = dateStringValue.length === 10
            ? Number(date) * 1000 // Convert the timestamp from seconds to milliseconds
            : Number(date);
        return new Date(timestamp);
    }
    try {
        return new Date(date);
    }
    catch (error) {
        return null;
    }
};
/**
 * Formats a Date object to a string in YYYY/MM/DD format.
 * The glue string is the separator between year, month and day.
 */
const dateFormatter = (date, glue) => `${date.getFullYear()}${glue}${(`0${date.getMonth() + 1}`).slice(-2)}${glue}${(`0${date.getDate()}`).slice(-2)}`;
/**
 * Corrct the offset of a Date object to UTC.
 */
const convertToUtc = (date) => {
    const dateValue = new Date(date);
    dateValue.setMinutes(dateValue.getMinutes() + dateValue.getTimezoneOffset());
    return dateValue;
};
/**
 * Convert a Date object to the thn string format yyyy/mm/dd.
 * @param [utc=true] - Denotes if the date is in UTC.
 * @param [glue='/'] - The glue string between year, month and day.
 */
const dateToString = (date, utc = true, glue = '/') => {
    const parsedDate = parseToDate(date);
    // Invalid date
    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
        return null;
    }
    if (!utc) {
        return dateFormatter(parsedDate, glue);
    }
    const utcDate = convertToUtc(parsedDate);
    return dateFormatter(utcDate, glue);
};

// jQuery Datepicker
function getDateFromJqueryDatepicker(selector, jQuery) {
    // needs jQuery
    if (!jQuery || !jQuery.fn.datepicker) {
        throw Error('jQuery or Datepicker missing');
    }
    // get date
    const date = jQuery(selector).datepicker('getDate');
    if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
        return undefined;
    }
    return date;
}
// Bootstrap Datepicker
function getDateFromBootstrapDatepicker(selector, jQuery) {
    // needs jQuery
    if (!jQuery || !jQuery.fn.datepicker) {
        throw new Error('jQuery or Datepicker missing');
    }
    // get date
    const date = jQuery(selector).data('datepicker').getDate();
    if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
        return undefined;
    }
    return date;
}
// Pickadate Datepicker
function getDateFromPickadateDatepicker(selector, jQuery) {
    // needs jQuery
    if (!jQuery || !jQuery.fn.pickadate) {
        throw new Error('jQuery or Pickadate missing');
    }
    // get date
    let date = jQuery(selector).pickadate('picker');
    date = date && date.get('select').obj;
    if (!date || (Object.prototype.hasOwnProperty.call(date, 'length') && date.length === 0)) {
        return undefined;
    }
    return date;
}
function getDateFromDatepicker(selector, options) {
    // defaults
    options = options || {};
    options.type = options.type || 'jquery';
    if (options.raw !== true) {
        options.raw = false;
    }
    // needs jQuery
    const $ = options.jQuery || globalThis.jQuery;
    // date
    let date;
    switch (options.type) {
        case 'bootstrap':
            date = getDateFromBootstrapDatepicker(selector, $);
            break;
        case 'pickadate':
            date = getDateFromPickadateDatepicker(selector, $);
            break;
        case 'jquery':
        default:
            date = getDateFromJqueryDatepicker(selector, $);
            break;
    }
    if (date && options.raw === false) {
        // as thn string
        date = dateToString(date);
    }
    return date;
}

export { getDateFromDatepicker as g };
